import { Button, Head, Link, Typography, useAuth } from "zudoku/components";

export const Landingpage = () => {

  return (
    <section>
      <Head>
        <title>Documentation</title>
      </Head>
    </section>
  );
};
